/* @ngInject */

export default (helperService, ObjectiveApplicant) => {
  /**
   * Set applicants plan to retire.
   *
   * @param {Array} objectives
   * @param {Array} contacts
   *
   * @returns {Array}
   */
  const setApplicants = (objectives, contacts) => {
    for (let c = 0; c < contacts.length; c += 1) {
      const idContact = contacts[c].id;
      const idx1 = helperService.findIndexByContactId(
        objectives.possibleAdverseChangesToFinancialSituation.applicants,
        contacts[c].id
      );
      if (idx1 === -1) {
        objectives.possibleAdverseChangesToFinancialSituation.applicants.push(
          ObjectiveApplicant.blank(idContact)
        );
      }
      const idx2 = helperService.findIndexByContactId(
        objectives.possibleBeneficialChangesToFinancialSituation.applicants,
        contacts[c].id
      );
      if (idx2 === -1) {
        objectives.possibleBeneficialChangesToFinancialSituation.applicants.push(
          ObjectiveApplicant.blank(idContact)
        );
      }
      const idx3 = helperService.findIndexByContactId(
        objectives.exitStrategy.planingToRetire,
        contacts[c].id
      );
      if (idx3 === -1) {
        objectives.exitStrategy.planingToRetire.push(ObjectiveApplicant.blank(idContact));
      }
      const idx4 = helperService.findIndexByContactId(
        objectives.creditHistory.bankruptcy,
        contacts[c].id
      );
      if (idx4 === -1) {
        objectives.creditHistory.bankruptcy.push(ObjectiveApplicant.blank(idContact));
      }
      const idx5 = helperService.findIndexByContactId(
        objectives.health.applicants,
        contacts[c].id
      );
      if (helperService.getOrganizationCountry().cca2 === 'NZ' && idx5 === -1) {
        objectives.health.applicants.push(ObjectiveApplicant.blank(idContact));
      }
    }
    return objectives;
  };

  return {
    setApplicants
  };
};
